import { Directive, ElementRef, SimpleChange, Input } from "@angular/core";

@Directive({
	selector: "[appHandleAnchorClick]",
})
export class HandleAnchorClickDirective {
	@Input()
	private anchorList: any;

	constructor(private el: ElementRef) {}

	ngOnChanges(changes: SimpleChange) {
		if (this.anchorList !== undefined && this.anchorList.length > 0) {
			this.anchorList.forEach((element) => {
				element.addEventListener("click", (event) => this.handleClick(element));
			});
		}
	}

	handleClick(elem) {
		//console.log("click working",evt);
		this.showDefinitionPopup(elem.getAttribute("class"));
	}
	public showDefinitionPopup(id) {
		console.log("showDefinition popup", id);
	}
}
